var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66667 3.08333C3.66667 2.46449 3.9125 1.871 4.35008 1.43342C4.78767 0.995833 5.38116 0.75 6 0.75C6.61884 0.75 7.21233 0.995833 7.64992 1.43342C8.0875 1.871 8.33333 2.46449 8.33333 3.08333C8.33333 3.70217 8.0875 4.29566 7.64992 4.73325C7.21233 5.17083 6.61884 5.41667 6 5.41667C5.38116 5.41667 4.78767 5.17083 4.35008 4.73325C3.9125 4.29566 3.66667 3.70217 3.66667 3.08333ZM3.66667 6.58333C2.89312 6.58333 2.15125 6.89062 1.60427 7.4376C1.05729 7.98459 0.75 8.72645 0.75 9.5C0.75 9.96413 0.934375 10.4092 1.26256 10.7374C1.59075 11.0656 2.03587 11.25 2.5 11.25H9.5C9.96413 11.25 10.4092 11.0656 10.7374 10.7374C11.0656 10.4092 11.25 9.96413 11.25 9.5C11.25 8.72645 10.9427 7.98459 10.3957 7.4376C9.84875 6.89062 9.10688 6.58333 8.33333 6.58333H3.66667Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.223014b7c103b572cad6c7dff3cb52be.svg";
export { ForwardRef as ReactComponent };